import api from './api';

export interface Token {
  authenticated: boolean;
  created: string;
  expiration: string;
  accessToken: string;
  refreshToken: string;
}

export interface Value {
  id: string;
  token: Token;
  nome: string;
  email: string;
  authenticated: boolean;
  message: string;
  acessos: any[];
  termoAceite:boolean;
  inserirMotoristasAdicionaisViagem: boolean;
}

export interface Response {
  value: Value;
  hasSuccess: boolean;
  hasError: boolean;
  errors: string[];
  httpStatusCode: number;
}

export interface Login {
  email: string;
  senha: string;
}



export function signIn(data: Login) {
  return api.post<Response>('login/login', data);
}
export function obterPermissoes(IdGrupo: any) {
  return api.get('seguranca/ObterMenu', { params: { IdGrupo } });
}



